import { detectAddressCountry } from '@Saral-Influencer-Marketing/saral-utils/dist/functions/addressHelper';
import { getLocationDetails } from '../services/util.service.js';

const removeEmojis = (str) => {
  const emojiPattern =
    /[\u{1F000}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F191}-\u{1F251}\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2B50}]/gu;

  return str.replace(emojiPattern, '');
};

const isAlphabetic = (char) => {
  return /^[\p{L}\p{M}]$/u.test(char);
};

const containsOnlyAlphabetsAndEmojis = (str) => {
  for (let char of str) {
    if (!isAlphabetic(char) && char.codePointAt(0) <= 127) {
      return false;
    }
  }
  return true;
};

export async function parseAddress(input) {
  let ogInput = input;

  const reversedInput = ogInput.split(' ').reverse().join();

  // First, detect country and postal code
  const countryInfo = detectAddressCountry(reversedInput);
  if (!countryInfo) {
    return false;
  }

  const locationData = await getLocationDetails(countryInfo.pincode);

  // Initialize the result
  const result = {
    addressLine1: '',
    country: countryInfo.country,
    pincode: countryInfo.pincode,
    addressLine2: '',
  };

  if (locationData.city) {
    result.city = locationData.city;
    ogInput = ogInput.replace(locationData.city, '');
  }

  if (locationData.country) {
    result.country = locationData.country;
    ogInput = ogInput.replace(locationData.country, '');
    if (locationData.country === 'United States') ogInput = ogInput.replace('US', '');
  }

  if (locationData.state) {
    result.state = locationData.state;
    ogInput = ogInput.replace(locationData.state, '');
  }

  // Remove the postal code from the input
  ogInput = ogInput.replace(countryInfo.pincode, '').trim();

  // Split the remaining address
  let parts = ogInput
    .split(/\n|,/)
    .map((part) => part.trim())
    .filter(Boolean);

  // Check if the first part is a name (only letters and spaces)
  if (parts.length > 0) {
    if (containsOnlyAlphabetsAndEmojis(parts[0])) {
      result.name = removeEmojis(parts.shift());
    }
  }

  // Assign parts to address fields
  if (parts.length > 0) result.addressLine1 = parts.shift() || '';
  if (parts.length > 0) result.addressLine2 = parts.shift();

  // Handle city and state
  if (!result.city && !result.state && parts.length > 1) {
    result.city = parts.shift();
    result.state = parts.shift();
  } else if (!result.city && parts.length === 1) {
    result.city = parts.shift();
  }

  // If there are still parts left, append to addressLine2
  if (parts.length > 0) {
    result.addressLine2 = (result.addressLine2 ? result.addressLine2 + ', ' : '') + parts.join(', ');
  }

  return result;
}
